export const TRACKER_LEFT = 'tracker_left';
export const TRACKER_RIGHT = 'tracker_right';



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/TrackerSide.ts